import { Container } from "react-bootstrap";
import IntegrateForm from "../../components/Integrate-form";
import { useState, useEffect } from "react";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useCreateShopMutation, useGetShopCategoriesQuery } from "../../features/shop/shopApiSlice";

const RetailerIntegrateform = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  
  const { data: categoryData } = useGetShopCategoriesQuery({ type: "retailerShop" });
  const shopCategoryone = categoryData?.data?.Category || [];

  const imageUrl = useSelector((state) => state.imgurl);
  const [integrateshop, setIntegrateshop] = useState({
    userid: name._id,
    shopaddress: "",
    shopUrl: "",
    isIntegrated: true,
    image: [""],
    shopCategory: "",
    businessType: "retailerShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setIntegrateshop((integrateshop) => ({
      ...integrateshop,
      image: imageUrl?.imgurl || "",
    }));
    // ...
  }, [imageUrl]);

  const [createShopMutation] = useCreateShopMutation();

  const HandlePost = async () => {
    try {
      const res = await createShopMutation(integrateshop).unwrap();
      if (res.success) {
        SuccessNotify("Shop Integrated Successfully");
        navigate("/retailer-integrate-form");
      }
    } catch (error) {
      FailedNotify("Failed to create Try Again!");
    }
  };

  return (
    <>
      <Container>
        <div className="screenHeight">
          <IntegrateForm
            backurl="/retailer-integrate"
            setIntegrateshop={setIntegrateshop}
            shopCategoryone={shopCategoryone}
            HandlePost={HandlePost}
          />
        </div>
      </Container>
    </>
  );
};

export default RetailerIntegrateform;
